import React from 'react';
import { css } from '@corti/style';
import { Loading } from 'lib/cortiUI';
export function LoadingOverlay() {
    return (React.createElement(Loading, { position: "absolute", top: "50%", left: "50%", className: css({
            transform: 'translate(-50%, -50%)',
        }) }));
}
